/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PaymentApiConfiguration } from '../payment-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';



/**
 * the PamCommandSendInstallmentLink API
 */
@Injectable({
  providedIn: 'root',
})
export class PamCommandSendInstallmentLinkService extends BaseService {
  constructor(
    config: PaymentApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation installmentUidPaymentGeneratePost
   */
  static readonly InstallmentUidPaymentGeneratePostPath = '/installment/{uid}/payment/generate';

  /**
   * Send link for installment based on specific installment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `installmentUidPaymentGeneratePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  installmentUidPaymentGeneratePost$Response(params: {
    uid: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, PamCommandSendInstallmentLinkService.InstallmentUidPaymentGeneratePostPath, 'post');
    if (params) {
      rb.path('uid', params.uid, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Send link for installment based on specific installment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `installmentUidPaymentGeneratePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  installmentUidPaymentGeneratePost(params: {
    uid: string;
  },
  context?: HttpContext

): Observable<void> {

    return this.installmentUidPaymentGeneratePost$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
